import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-[100] flex items-center justify-center p-4",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": 'confirm-modal-title'
}
const _hoisted_2 = { class: "relative w-full max-w-md rounded-2xl bg-white shadow-2xl border border-slate-200 overflow-hidden" }
const _hoisted_3 = { class: "px-6 py-4 text-sm text-slate-600 leading-relaxed" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "w-full sm:w-auto shrink-0 min-w-0 sm:min-w-[7rem]" }
const _hoisted_6 = { class: "w-full sm:w-auto shrink-0 min-w-0 sm:min-w-[7rem]" }

import { computed, watch, onUnmounted } from "vue";
import AdminModalHeader from "@/share/components/admin/AdminModalHeader.vue";
import AdminModalFooter from "@/share/components/admin/AdminModalFooter.vue";
import AdminButton from "@/share/components/admin/AdminButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmarAccionModal',
  props: {
    show: { type: Boolean },
    title: {},
    message: { default: "" },
    confirmLabel: { default: "Confirmar" },
    cancelLabel: { default: "Cancelar" },
    loading: { type: Boolean, default: false },
    variant: { default: "danger" }
  },
  emits: ["confirm", "cancel"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const onKeydown = (ev: KeyboardEvent) => {
  if (!props.show || props.loading) return;
  if (ev.key === "Escape") emit("cancel");
};

watch(
  () => props.show,
  (open) => {
    if (open) {
      document.addEventListener("keydown", onKeydown);
      document.body.style.overflow = "hidden";
    } else {
      document.removeEventListener("keydown", onKeydown);
      document.body.style.overflow = "";
    }
  }
);

onUnmounted(() => {
  document.removeEventListener("keydown", onKeydown);
  document.body.style.overflow = "";
});

const confirmButtonVariant = computed(() =>
  props.variant === "primary" ? "primary" : "danger"
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      "enter-active-class": "transition-opacity duration-200",
      "leave-active-class": "transition-opacity duration-150",
      "enter-from-class": "opacity-0",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (__props.show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "absolute inset-0 bg-slate-900/60 backdrop-blur-sm",
                "aria-hidden": "true",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (!__props.loading && emit('cancel')))
              }),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(AdminModalHeader, {
                  variant: "light",
                  title: __props.title,
                  "heading-id": "confirm-modal-title",
                  "top-rounded": false,
                  "show-close": false
                }, null, 8, ["title"]),
                _createElementVNode("div", _hoisted_3, [
                  _renderSlot(_ctx.$slots, "default", {}, () => [
                    (__props.message)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.message), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode(AdminModalFooter, { "rounded-bottom": "" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(AdminButton, {
                        variant: "secondary",
                        block: "",
                        disabled: __props.loading,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancel')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.cancelLabel), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(AdminButton, {
                        variant: confirmButtonVariant.value,
                        block: "",
                        loading: __props.loading,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('confirm')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.loading ? "Procesando…" : __props.confirmLabel), 1)
                        ]),
                        _: 1
                      }, 8, ["variant", "loading"])
                    ])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})